import { css } from '@emotion/react';

export const globalStyles = css`
  * {
    box-sizing: border-box;
  }

  html, body {
    margin: 0;
    padding: 0;
    height: 100%;
    font-family: 'Roboto', 'Helvetica', 'Arial', sans-serif;
  }

  #root {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  /* Smooth scrolling */
  html {
    scroll-behavior: smooth;
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
  }

  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  ::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
  }

  ::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
  }

  /* Focus styles for accessibility */
  *:focus {
    outline: 2px solid #1976d2;
    outline-offset: 2px;
  }

  /* Loading animation */
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }

  .pulse {
    animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
  }

  /* Fade in animation */
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(10px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  .fade-in {
    animation: fadeIn 0.3s ease-out;
  }

  /* Responsive utilities */
  .hide-on-mobile {
    @media (max-width: 768px) {
      display: none !important;
    }
  }

  .show-on-mobile {
    @media (min-width: 769px) {
      display: none !important;
    }
  }

  /* Currency flag styles */
  .currency-flag {
    font-size: 1.2em;
    margin-right: 8px;
  }

  /* Rate change indicators */
  .rate-up {
    color: #4caf50;
  }

  .rate-down {
    color: #f44336;
  }

  .rate-stable {
    color: #9e9e9e;
  }

  /* Card hover effects */
  .hover-card {
    transition: transform 0.2s ease, box-shadow 0.2s ease;
  }

  .hover-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15) !important;
  }

  /* Button loading state */
  .loading-button {
    position: relative;
    pointer-events: none;
  }

  .loading-button::after {
    content: '';
    position: absolute;
    top: 50%;
    left: 50%;
    width: 16px;
    height: 16px;
    margin: -8px 0 0 -8px;
    border: 2px solid transparent;
    border-top: 2px solid currentColor;
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  /* Error message styles */
  .error-message {
    background-color: #ffebee;
    color: #c62828;
    padding: 12px;
    border-radius: 4px;
    border-left: 4px solid #f44336;
    margin: 8px 0;
  }

  /* Success message styles */
  .success-message {
    background-color: #e8f5e8;
    color: #2e7d32;
    padding: 12px;
    border-radius: 4px;
    border-left: 4px solid #4caf50;
    margin: 8px 0;
  }

  /* Info message styles */
  .info-message {
    background-color: #e3f2fd;
    color: #1565c0;
    padding: 12px;
    border-radius: 4px;
    border-left: 4px solid #2196f3;
    margin: 8px 0;
  }

  /* Responsive grid */
  .responsive-grid {
    display: grid;
    gap: 16px;
    grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  }

  /* Mobile-first responsive design */
  @media (max-width: 600px) {
    .responsive-grid {
      grid-template-columns: 1fr;
      gap: 12px;
    }
  }

  /* Print styles */
  @media print {
    .no-print {
      display: none !important;
    }
  }
`; 